import { HttpErrorResponse } from '@angular/common/http';

export class ResourceError extends Error{
    constructor(
        public status: number,
        message: string,
        public data?: any){
        super(message);
    }
}

export enum ResourceStatus {
    NotAuthorized = 403,
    NotFound = 404,
    InternalServerError = 500
}

export interface IAFIHttpErrorResponse extends HttpErrorResponse{
    data?: any;
}